import { HttpClient, HttpResponse } from "@angular/common/http";
import { TranslateService } from "@ngx-translate/core";
import { globals } from "../utils/globals";
import { Observable, throwError } from "rxjs";
import { map, retry, catchError, tap } from "rxjs/operators";
import { ImaginaeToken } from "src/app/models/imaginae-token.model";
import { TransferStateService } from "./transfer-state.service";

export class HttpService<T> {
  constructor(
    protected _http: HttpClient,
    protected _translateService: TranslateService,
    protected _globals: globals,
    protected _transferStateService: TransferStateService
  ) {}

  /**
   * Petición HTTP GET a la URL del servidor, con los datos y cabecera recibidos.
   **/
  protected _get(url: any, data: any, header: any): Observable<T> {
    let options =
      typeof data != "undefined" && data != null
        ? { params: data, headers: header }
        : { headers: header };
    return this._http
      .get<T>(url, options);
  }

  protected _getList(url: any, data: any, header: any): Observable<T[]> {
    header[this._globals.constants.HEADER_ACCEPT_LANGUAGE] =
      this._translateService.currentLang;
    let options =
      typeof data != "undefined" && data != null
        ? { params: data, headers: header }
        : { headers: header };
    return this._http
      .get<T[]>(url, options)
      .pipe(retry(1), catchError(this._handleError));
  }

  /**
   * Petición HTTP POST a la URL del servidor, con los datos y cabecera recibidos. Los datos
   * se envían al servidor como si fueran de un formulario.
   **/
  protected _post(url: any, data: any, header: any): Observable<T> {
    //console.log(data);

    let jsonData: boolean = false;
    for (var i in header) {
      if (
        i === this._globals.constants.HEADER_CONTENT_TYPE &&
        header[i] === this._globals.constants.HEADER_ACCEPT_JSON_VALUE
      )
        jsonData = true;
    }
    let dataTransform: any;
    dataTransform = jsonData ? data : this.transformRequest(data, header);
    header = this.addCommonHeaders(header);
    const options = new HttpResponse({ headers: header });

    return this._http.post(url, dataTransform, options).pipe(
      map((res: any) => {
        //console.log('_post ha hecho el post');
        if (res != null) {
          //console.log('result=' + res);
          const data = res as T;
          return data;
        }
        return res;
      }),
      retry(1),
      catchError(this._handleError)
    );
  }

  /**
   * Petición HTTP POST a la URL del servidor, con los datos y cabecera recibidos. Los datos
   * se envían al servidor como si fueran de un formulario.
   **/
  protected _postList(url: any, data: any, header: any): Observable<T[]> {
    //console.log(data);
    let jsonData: boolean = false;
    for (var i in header) {
      if (
        i === this._globals.constants.HEADER_CONTENT_TYPE &&
        header[i] === this._globals.constants.HEADER_ACCEPT_JSON_VALUE
      )
        jsonData = true;
    }
    let dataTransform: any;
    dataTransform = jsonData ? data : this.transformRequest(data, header);

    if (!header) header = new Array();
    header.push("Access-Control-Allow-Origin: *");

    const options = new HttpResponse({
      headers: header,
    });

    return this._http.post(url, dataTransform, options).pipe(
      map((res: any) => {
        if (res != null) {
          //console.log('result=' + res);
          const data = res as T[];
          return data;
        }

        return res;
      }),
      retry(1),
      catchError(this._handleError)
    );
  }

  /**
   * Petición HTTP POST a la URL del servidor, con los datos y cabecera recibidos. Los datos
   * se envían al servidor como si fueran de un formulario.
   **/
  protected _postAttachment(url: any, data: any): Observable<T> {
    //console.log(data);
    const options = new HttpResponse();
    //console.log(data);
    return this._http.post(url, data).pipe(
      tap((res: any) => {
        //console.log("Respuesta del servidor: ", res);
      }),
      map((res: any) => {
        //console.log("Entrando a la función de mapeo");
        //console.log("Respuesta después de mapeo: ", res);

        if (res != null) {
          const data = res as T;
          //console.log("Datos transformados: ", data);
          return data;
        }

        return res;
      }),
      retry(1),
      catchError((error: any) => {
        console.error("Error en la solicitud: ", error);
        return this._handleError(error, "hola");
      })
    );
  }

  // Error handling
  protected _handleError(error: any, self: any) {
    let errorMessage = "";
    if (error.status == 404) {
      return throwError(() => error);
    }
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    let errorToSend: Error = new Error(errorMessage);
    switch (error.status) {
      case 0:
        break;
      case 401:
        let newToken = new ImaginaeToken();
        this._transferStateService.setItem("tokenInfo", newToken);
        setTimeout("location.reload(true);", 300);
        break;
      default:
        console.error("Error on making call");
        break;
    }

    return throwError(() => errorMessage);
  }

  /**
   * Petición HTTP con la configuración recibida, que se mapea directamente en el
   * servicio $http de AngularJS.
   * need to test because i dont know how this function will use
   **/
  /*	Http(config: any) {
		config.headers = this.globals.constants.HEADER_ACCEPT_LANGUAGE, this.translate.currentLang;
		let petition = this.http.request(config);
		return this.makeRequest(petition);
	}*/

  /**
   * Hace la petición recibida. Gestiona algunos errores
   */
  /*	return petition.subscribe((res: Response) => {
			return res;
		});
	}*/

  transformRequest(data: any, getHeaders: any) {
    //console.log(data);
    // If this is not an object, defer to native stringification.
    if (typeof data != "object") {
      let dataR = data == null ? "" : data.toString();
      return dataR;
    } else {
      let buffer = [];

      // Serialize each key in the object.
      for (let name in data) {
        if (!data.hasOwnProperty(name)) {
          continue;
        }
        let value = data[name];

        buffer.push(
          encodeURIComponent(name) +
            "=" +
            encodeURIComponent(value == null ? "" : value)
        );
      }
      // Serialize the buffer and clean it up for transportation.
      let source = buffer.join("&").replace(/%20/g, "+");

      return source;
    }
  }

  /**
   * Añade a las cabeceras la del idioma de la app.
   */
  addCommonHeaders(headers: any = null) {
    if (typeof headers == "undefined" || headers == null) headers = {};
    headers["Access-Control-Allow-Origin"] = "*";
    return headers;
  }
}
